import { type FC } from 'react';

import CorporateFareOutlined from '@mui/icons-material/CorporateFareOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { HasFeatureFlag } from '@/src/features/integrations/statsig/components/HasFeatureFlag';

import { AdminNavLinks } from './AdminNavLinks';
import { NavDivider } from './NavDivider';

export const SponsorAdminNavLinks: FC = () => (
  <>
    <HasFeatureFlag.DashboardMetabase>
      <SideNavButton icon={DashboardOutlined} page='dashboard'>
        Dashboard
      </SideNavButton>
    </HasFeatureFlag.DashboardMetabase>
    <NavDivider />
    <SideNavButton icon={CorporateFareOutlined} page='sponsored-organizations'>
      Organizations
    </SideNavButton>
    <AdminNavLinks />
  </>
);
